import * as Yup from 'yup'

const Regex = "^[A-Za-z0-9]+$"
const validationSchema = Yup.object().shape({
    nombre: Yup.string().matches(Regex, {message: 'No puede contener caracteres especiales', excludeEmptyString: true})
})

export default validationSchema